import { render, staticRenderFns } from "./WorkplaceDialog.vue?vue&type=template&id=fba9fd2a"
import script from "./WorkplaceDialog.vue?vue&type=script&lang=ts"
export * from "./WorkplaceDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports